import { PostQuoteJobCatCount } from "../post-models/post-quote-job-cat-count";

export class PutQuoteJobCatCount extends PostQuoteJobCatCount {
    id?: number;
}